<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex flex-column gap-1 flex-grow-1">
      <div i18n class="detail-label">Next Payment</div>
      <app-text-button [type]="ButtonTypeEnum.accent" (buttonClicked)="viewUpcomingPayments.emit()" i18n>
        View Upcoming Payments
      </app-text-button>
    </div>
    <div i18n class="detail-value next-payment-date">{{ nextPaymentDate | date : 'MMMM yyyy' }}</div>
  </div>
</div>
